// Keep PDF generation out of the initial page bundle.
export async function downloadResumePdf(preview) {
  const pages = Array.from(preview.querySelectorAll("section.resume-docx"));
  if (!pages.length) throw new Error("The resume is not ready");

  const { jsPDF } = await import("jspdf");
  const pdf = new jsPDF({ unit: "pt", format: "a4", compress: true });
  pdf.setProperties({ title: "Wayne Jiang - CV" });

  for (const [index, page] of pages.entries()) {
    if (index > 0) pdf.addPage();
    const source = page.cloneNode(true);
    // Export the original Word layout, independent of the preview's screen scale.
    source.style.margin = "0";
    source.style.boxShadow = "none";
    source.style.minHeight = "0";
    const width = parseFloat(window.getComputedStyle(page).width);
    await pdf.html(source, {
      width: pdf.internal.pageSize.getWidth(),
      windowWidth: width,
      y: (pdf.getNumberOfPages() - 1) * pdf.internal.pageSize.getHeight(),
      autoPaging: "text",
      html2canvas: { backgroundColor: "#ffffff", logging: false },
    });
  }

  await pdf.save("wayne-cv.pdf", { returnPromise: true });
}
